(() => {
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __commonJS = (cb, mod) => function __require() {
    return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
  };

  // node_modules/js-aruco2/src/cv.js
  var require_cv = __commonJS({
    "node_modules/js-aruco2/src/cv.js"(exports) {
      var CV = CV || {};
      exports.CV = CV;
      CV.Image = function(width, height, data) {
        this.width = width || 0;
        this.height = height || 0;
        this.data = data || [];
      };
      CV.grayscale = function(imageSrc, imageDst) {
        var src = imageSrc.data, dst = imageDst.data, len = src.length, i = 0, j = 0;
        for (; i < len; i += 4) {
          dst[j++] = src[i] * 0.299 + src[i + 1] * 0.587 + src[i + 2] * 0.114 + 0.5 & 255;
        }
        imageDst.width = imageSrc.width;
        imageDst.height = imageSrc.height;
        return imageDst;
      };
      CV.threshold = function(imageSrc, imageDst, threshold) {
        var src = imageSrc.data, dst = imageDst.data, len = src.length, tab = [], i;
        for (i = 0; i < 256; ++i) {
          tab[i] = i <= threshold ? 0 : 255;
        }
        for (i = 0; i < len; ++i) {
          dst[i] = tab[src[i]];
        }
        imageDst.width = imageSrc.width;
        imageDst.height = imageSrc.height;
        return imageDst;
      };
      CV.adaptiveThreshold = function(imageSrc, imageDst, kernelSize, threshold) {
        var src = imageSrc.data, dst = imageDst.data, len = src.length, tab = [], i;
        CV.stackBoxBlur(imageSrc, imageDst, kernelSize);
        for (i = 0; i < 768; ++i) {
          tab[i] = i - 255 <= -threshold ? 255 : 0;
        }
        for (i = 0; i < len; ++i) {
          dst[i] = tab[src[i] - dst[i] + 255];
        }
        imageDst.width = imageSrc.width;
        imageDst.height = imageSrc.height;
        return imageDst;
      };
      CV.otsu = function(imageSrc) {
        var src = imageSrc.data, len = src.length, hist = [], threshold = 0, sum = 0, sumB = 0, wB = 0, wF = 0, max = 0, mu, between, i;
        for (i = 0; i < 256; ++i) {
          hist[i] = 0;
        }
        for (i = 0; i < len; ++i) {
          hist[src[i]]++;
        }
        for (i = 0; i < 256; ++i) {
          sum += hist[i] * i;
        }
        for (i = 0; i < 256; ++i) {
          wB += hist[i];
          if (0 !== wB) {
            wF = len - wB;
            if (0 === wF) {
              break;
            }
            sumB += hist[i] * i;
            mu = sumB / wB - (sum - sumB) / wF;
            between = wB * wF * mu * mu;
            if (between > max) {
              max = between;
              threshold = i;
            }
          }
        }
        return threshold;
      };
      CV.stackBoxBlurMult = [1, 171, 205, 293, 57, 373, 79, 137, 241, 27, 391, 357, 41, 19, 283, 265];
      CV.stackBoxBlurShift = [0, 9, 10, 11, 9, 12, 10, 11, 12, 9, 13, 13, 10, 9, 13, 13];
      CV.BlurStack = function() {
        this.color = 0;
        this.next = null;
      };
      CV.stackBoxBlur = function(imageSrc, imageDst, kernelSize) {
        var src = imageSrc.data, dst = imageDst.data, height = imageSrc.height, width = imageSrc.width, heightMinus1 = height - 1, widthMinus1 = width - 1, size = kernelSize + kernelSize + 1, radius = kernelSize + 1, mult = CV.stackBoxBlurMult[kernelSize], shift = CV.stackBoxBlurShift[kernelSize], stack, stackStart, color, sum, pos, start, p, x, y, i;
        stack = stackStart = new CV.BlurStack();
        for (i = 1; i < size; ++i) {
          stack = stack.next = new CV.BlurStack();
        }
        stack.next = stackStart;
        pos = 0;
        for (y = 0; y < height; ++y) {
          start = pos;
          color = src[pos];
          sum = radius * color;
          stack = stackStart;
          for (i = 0; i < radius; ++i) {
            stack.color = color;
            stack = stack.next;
          }
          for (i = 1; i < radius; ++i) {
            stack.color = src[pos + i];
            sum += stack.color;
            stack = stack.next;
          }
          stack = stackStart;
          for (x = 0; x < width; ++x) {
            dst[pos++] = sum * mult >>> shift;
            p = x + radius;
            p = start + (p < widthMinus1 ? p : widthMinus1);
            sum -= stack.color - src[p];
            stack.color = src[p];
            stack = stack.next;
          }
        }
        for (x = 0; x < width; ++x) {
          pos = x;
          start = pos + width;
          color = dst[pos];
          sum = radius * color;
          stack = stackStart;
          for (i = 0; i < radius; ++i) {
            stack.color = color;
            stack = stack.next;
          }
          for (i = 1; i < radius; ++i) {
            stack.color = dst[start];
            sum += stack.color;
            stack = stack.next;
            start += width;
          }
          stack = stackStart;
          for (y = 0; y < height; ++y) {
            dst[pos] = sum * mult >>> shift;
            p = y + radius;
            p = x + (p < heightMinus1 ? p : heightMinus1) * width;
            sum -= stack.color - dst[p];
            stack.color = dst[p];
            stack = stack.next;
            pos += width;
          }
        }
        return imageDst;
      };
      CV.gaussianBlur = function(imageSrc, imageDst, imageMean, kernelSize) {
        var kernel = CV.gaussianKernel(kernelSize);
        imageDst.width = imageSrc.width;
        imageDst.height = imageSrc.height;
        imageMean.width = imageSrc.width;
        imageMean.height = imageSrc.height;
        CV.gaussianBlurFilter(imageSrc, imageMean, kernel, true);
        CV.gaussianBlurFilter(imageMean, imageDst, kernel, false);
        return imageDst;
      };
      CV.gaussianBlurFilter = function(imageSrc, imageDst, kernel, horizontal) {
        var src = imageSrc.data, dst = imageDst.data, height = imageSrc.height, width = imageSrc.width, pos = 0, limit = kernel.length >> 1, cur, value, i, j, k;
        for (i = 0; i < height; ++i) {
          for (j = 0; j < width; ++j) {
            value = 0;
            for (k = -limit; k <= limit; ++k) {
              if (horizontal) {
                cur = pos + k;
                if (j + k < 0) {
                  cur = pos;
                } else if (j + k >= width) {
                  cur = pos;
                }
              } else {
                cur = pos + k * width;
                if (i + k < 0) {
                  cur = pos;
                } else if (i + k >= height) {
                  cur = pos;
                }
              }
              value += kernel[limit + k] * src[cur];
            }
            dst[pos++] = horizontal ? value : value + 0.5 & 255;
          }
        }
        return imageDst;
      };
      CV.gaussianKernel = function(kernelSize) {
        var tab = [
          [1],
          [0.25, 0.5, 0.25],
          [0.0625, 0.25, 0.375, 0.25, 0.0625],
          [0.03125, 0.109375, 0.21875, 0.28125, 0.21875, 0.109375, 0.03125]
        ], kernel = [], center, sigma, scale2X, sum, x, i;
        if (kernelSize <= 7 && kernelSize % 2 === 1) {
          kernel = tab[kernelSize >> 1];
        } else {
          center = (kernelSize - 1) * 0.5;
          sigma = 0.8 + 0.3 * (center - 1);
          scale2X = -0.5 / (sigma * sigma);
          sum = 0;
          for (i = 0; i < kernelSize; ++i) {
            x = i - center;
            sum += kernel[i] = Math.exp(scale2X * x * x);
          }
          sum = 1 / sum;
          for (i = 0; i < kernelSize; ++i) {
            kernel[i] *= sum;
          }
        }
        return kernel;
      };
      CV.findContours = function(imageSrc, binary) {
        var width = imageSrc.width, height = imageSrc.height, contours = [], src, deltas, pos, pix, nbd, outer, hole, i, j;
        src = CV.binaryBorder(imageSrc, binary);
        deltas = CV.neighborhoodDeltas(width + 2);
        pos = width + 3;
        nbd = 1;
        for (i = 0; i < height; ++i, pos += 2) {
          for (j = 0; j < width; ++j, ++pos) {
            pix = src[pos];
            if (0 !== pix) {
              outer = hole = false;
              if (1 === pix && 0 === src[pos - 1]) {
                outer = true;
              } else if (pix >= 1 && 0 === src[pos + 1]) {
                hole = true;
              }
              if (outer || hole) {
                ++nbd;
                contours.push(CV.borderFollowing(src, pos, nbd, { x: j, y: i }, hole, deltas));
              }
            }
          }
        }
        return contours;
      };
      CV.borderFollowing = function(src, pos, nbd, point, hole, deltas) {
        var contour = [], pos1, pos3, pos4, s, s_end, s_prev;
        contour.hole = hole;
        s = s_end = hole ? 0 : 4;
        do {
          s = s - 1 & 7;
          pos1 = pos + deltas[s];
          if (src[pos1] !== 0) {
            break;
          }
        } while (s !== s_end);
        if (s === s_end) {
          src[pos] = -nbd;
          contour.push({ x: point.x, y: point.y });
        } else {
          pos3 = pos;
          s_prev = s ^ 4;
          while (true) {
            s_end = s;
            do {
              pos4 = pos3 + deltas[++s];
            } while (src[pos4] === 0);
            s &= 7;
            if (s - 1 >>> 0 < s_end >>> 0) {
              src[pos3] = -nbd;
            } else if (src[pos3] === 1) {
              src[pos3] = nbd;
            }
            contour.push({ x: point.x, y: point.y });
            s_prev = s;
            point.x += CV.neighborhood[s][0];
            point.y += CV.neighborhood[s][1];
            if (pos4 === pos && pos3 === pos1) {
              break;
            }
            pos3 = pos4;
            s = s + 4 & 7;
          }
        }
        return contour;
      };
      CV.neighborhood = [[1, 0], [1, -1], [0, -1], [-1, -1], [-1, 0], [-1, 1], [0, 1], [1, 1]];
      CV.neighborhoodDeltas = function(width) {
        var deltas = [], len = CV.neighborhood.length, i = 0;
        for (; i < len; ++i) {
          deltas[i] = CV.neighborhood[i][0] + CV.neighborhood[i][1] * width;
        }
        return deltas.concat(deltas);
      };
      CV.approxPolyDP = function(contour, epsilon) {
        var slice = { start_index: 0, end_index: 0 }, right_slice = { start_index: 0, end_index: 0 }, poly = [], stack = [], len = contour.length, pt, start_pt, end_pt, dist, max_dist, le_eps, dx, dy, i, j, k;
        epsilon *= epsilon;
        k = 0;
        for (i = 0; i < 3; ++i) {
          max_dist = 0;
          k = (k + right_slice.start_index) % len;
          start_pt = contour[k];
          if (++k === len) {
            k = 0;
          }
          for (j = 1; j < len; ++j) {
            pt = contour[k];
            if (++k === len) {
              k = 0;
            }
            dx = pt.x - start_pt.x;
            dy = pt.y - start_pt.y;
            dist = dx * dx + dy * dy;
            if (dist > max_dist) {
              max_dist = dist;
              right_slice.start_index = j;
            }
          }
        }
        if (max_dist <= epsilon) {
          poly.push({ x: start_pt.x, y: start_pt.y });
        } else {
          slice.start_index = k;
          slice.end_index = right_slice.start_index += slice.start_index;
          right_slice.start_index -= right_slice.start_index >= len ? len : 0;
          right_slice.end_index = slice.start_index;
          if (right_slice.end_index < right_slice.start_index) {
            right_slice.end_index += len;
          }
          stack.push({ start_index: right_slice.start_index, end_index: right_slice.end_index });
          stack.push({ start_index: slice.start_index, end_index: slice.end_index });
        }
        while (stack.length !== 0) {
          slice = stack.pop();
          end_pt = contour[slice.end_index % len];
          start_pt = contour[k = slice.start_index % len];
          if (++k === len) {
            k = 0;
          }
          if (slice.end_index <= slice.start_index + 1) {
            le_eps = true;
          } else {
            max_dist = 0;
            dx = end_pt.x - start_pt.x;
            dy = end_pt.y - start_pt.y;
            for (i = slice.start_index + 1; i < slice.end_index; ++i) {
              pt = contour[k];
              if (++k === len) {
                k = 0;
              }
              dist = Math.abs((pt.y - start_pt.y) * dx - (pt.x - start_pt.x) * dy);
              if (dist > max_dist) {
                max_dist = dist;
                right_slice.start_index = i;
              }
            }
            le_eps = max_dist * max_dist <= epsilon * (dx * dx + dy * dy);
          }
          if (le_eps) {
            poly.push({ x: start_pt.x, y: start_pt.y });
          } else {
            right_slice.end_index = slice.end_index;
            slice.end_index = right_slice.start_index;
            stack.push({ start_index: right_slice.start_index, end_index: right_slice.end_index });
            stack.push({ start_index: slice.start_index, end_index: slice.end_index });
          }
        }
        return poly;
      };
      CV.warp = function(imageSrc, imageDst, contour, warpSize) {
        var src = imageSrc.data, dst = imageDst.data, width = imageSrc.width, height = imageSrc.height, pos = 0, sx1, sx2, dx1, dx2, sy1, sy2, dy1, dy2, p1, p2, p3, p4, m, r, s, t, u, v, w, x, y, i, j;
        m = CV.getPerspectiveTransform(contour, warpSize - 1);
        r = m[8];
        s = m[2];
        t = m[5];
        for (i = 0; i < warpSize; ++i) {
          r += m[7];
          s += m[1];
          t += m[4];
          u = r;
          v = s;
          w = t;
          for (j = 0; j < warpSize; ++j) {
            u += m[6];
            v += m[0];
            w += m[3];
            x = v / u;
            y = w / u;
            sx1 = x >>> 0;
            sx2 = sx1 === width - 1 ? sx1 : sx1 + 1;
            dx1 = x - sx1;
            dx2 = 1 - dx1;
            sy1 = y >>> 0;
            sy2 = sy1 === height - 1 ? sy1 : sy1 + 1;
            dy1 = y - sy1;
            dy2 = 1 - dy1;
            p1 = p2 = sy1 * width;
            p3 = p4 = sy2 * width;
            dst[pos++] = dy2 * (dx2 * src[p1 + sx1] + dx1 * src[p2 + sx2]) + dy1 * (dx2 * src[p3 + sx1] + dx1 * src[p4 + sx2]) & 255;
          }
        }
        imageDst.width = warpSize;
        imageDst.height = warpSize;
        return imageDst;
      };
      CV.getPerspectiveTransform = function(src, size) {
        var rq = CV.square2quad(src);
        rq[0] /= size;
        rq[1] /= size;
        rq[3] /= size;
        rq[4] /= size;
        rq[6] /= size;
        rq[7] /= size;
        return rq;
      };
      CV.square2quad = function(src) {
        var sq = [], px, py, dx1, dx2, dy1, dy2, den;
        px = src[0].x - src[1].x + src[2].x - src[3].x;
        py = src[0].y - src[1].y + src[2].y - src[3].y;
        if (0 === px && 0 === py) {
          sq[0] = src[1].x - src[0].x;
          sq[1] = src[2].x - src[1].x;
          sq[2] = src[0].x;
          sq[3] = src[1].y - src[0].y;
          sq[4] = src[2].y - src[1].y;
          sq[5] = src[0].y;
          sq[6] = 0;
          sq[7] = 0;
          sq[8] = 1;
        } else {
          dx1 = src[1].x - src[2].x;
          dx2 = src[3].x - src[2].x;
          dy1 = src[1].y - src[2].y;
          dy2 = src[3].y - src[2].y;
          den = dx1 * dy2 - dx2 * dy1;
          sq[6] = (px * dy2 - dx2 * py) / den;
          sq[7] = (dx1 * py - px * dy1) / den;
          sq[8] = 1;
          sq[0] = src[1].x - src[0].x + sq[6] * src[1].x;
          sq[1] = src[3].x - src[0].x + sq[7] * src[3].x;
          sq[2] = src[0].x;
          sq[3] = src[1].y - src[0].y + sq[6] * src[1].y;
          sq[4] = src[3].y - src[0].y + sq[7] * src[3].y;
          sq[5] = src[0].y;
        }
        return sq;
      };
      CV.isContourConvex = function(contour) {
        var orientation = 0, convex = true, len = contour.length, i = 0, j = 0, cur_pt, prev_pt, dxdy0, dydx0, dx0, dy0, dx, dy;
        prev_pt = contour[len - 1];
        cur_pt = contour[0];
        dx0 = cur_pt.x - prev_pt.x;
        dy0 = cur_pt.y - prev_pt.y;
        for (; i < len; ++i) {
          if (++j === len) {
            j = 0;
          }
          prev_pt = cur_pt;
          cur_pt = contour[j];
          dx = cur_pt.x - prev_pt.x;
          dy = cur_pt.y - prev_pt.y;
          dxdy0 = dx * dy0;
          dydx0 = dy * dx0;
          orientation |= dydx0 > dxdy0 ? 1 : dydx0 < dxdy0 ? 2 : 3;
          if (3 === orientation) {
            convex = false;
            break;
          }
          dx0 = dx;
          dy0 = dy;
        }
        return convex;
      };
      CV.perimeter = function(poly) {
        var len = poly.length, i = 0, j = len - 1, p = 0, dx, dy;
        for (; i < len; j = i++) {
          dx = poly[i].x - poly[j].x;
          dy = poly[i].y - poly[j].y;
          p += Math.sqrt(dx * dx + dy * dy);
        }
        return p;
      };
      CV.minEdgeLength = function(poly) {
        var len = poly.length, i = 0, j = len - 1, min = Infinity, d, dx, dy;
        for (; i < len; j = i++) {
          dx = poly[i].x - poly[j].x;
          dy = poly[i].y - poly[j].y;
          d = dx * dx + dy * dy;
          if (d < min) {
            min = d;
          }
        }
        return Math.sqrt(min);
      };
      CV.countNonZero = function(imageSrc, square) {
        var src = imageSrc.data, height = square.height, width = square.width, pos = square.x + square.y * imageSrc.width, span = imageSrc.width - width, nz = 0, i, j;
        for (i = 0; i < height; ++i) {
          for (j = 0; j < width; ++j) {
            if (0 !== src[pos++]) {
              ++nz;
            }
          }
          pos += span;
        }
        return nz;
      };
      CV.binaryBorder = function(imageSrc, dst) {
        var src = imageSrc.data, height = imageSrc.height, width = imageSrc.width, posSrc = 0, posDst = 0, i, j;
        for (j = -2; j < width; ++j) {
          dst[posDst++] = 0;
        }
        for (i = 0; i < height; ++i) {
          dst[posDst++] = 0;
          for (j = 0; j < width; ++j) {
            dst[posDst++] = 0 === src[posSrc++] ? 0 : 1;
          }
          dst[posDst++] = 0;
        }
        for (j = -2; j < width; ++j) {
          dst[posDst++] = 0;
        }
        return dst;
      };
    }
  });

  // node_modules/js-aruco2/src/aruco.js
  var require_aruco = __commonJS({
    "node_modules/js-aruco2/src/aruco.js"(exports) {
      var AR = {};
      var CV = exports.CV || require_cv().CV;
      exports.AR = AR;
      AR.DICTIONARIES = {
        ARUCO: {
          nBits: 25,
          tau: 3,
          codeList: [17318416, 17318423, 17318409, 17318414, 17318640, 17318647, 17318633, 17318638, 17318192, 17318199, 17318185, 17318190, 17318352, 17318359, 17318345, 17318350, 17325584, 17325591, 17325577, 17325582, 17325808, 17325815, 17325801, 17325806, 17325360, 17325367, 17325353, 17325358, 17325520, 17325527, 17325513, 17325518, 17311248, 17311255, 17311241, 17311246, 17311472, 17311479, 17311465, 17311470, 17311024, 17311031, 17311017, 17311022, 17311184, 17311191, 17311177, 17311182, 17316368, 17316375, 17316361, 17316366, 17316592, 17316599, 17316585, 17316590, 17316144, 17316151, 17316137, 17316142, 17316304, 17316311, 17316297, 17316302, 17547792, 17547799, 17547785, 17547790, 17548016, 17548023, 17548009, 17548014, 17547568, 17547575, 17547561, 17547566, 17547728, 17547735, 17547721, 17547726, 17554960, 17554967, 17554953, 17554958, 17555184, 17555191, 17555177, 17555182, 17554736, 17554743, 17554729, 17554734, 17554896, 17554903, 17554889, 17554894, 17540624, 17540631, 17540617, 17540622, 17540848, 17540855, 17540841, 17540846, 17540400, 17540407, 17540393, 17540398, 17540560, 17540567, 17540553, 17540558, 17545744, 17545751, 17545737, 17545742, 17545968, 17545975, 17545961, 17545966, 17545520, 17545527, 17545513, 17545518, 17545680, 17545687, 17545673, 17545678, 17089040, 17089047, 17089033, 17089038, 17089264, 17089271, 17089257, 17089262, 17088816, 17088823, 17088809, 17088814, 17088976, 17088983, 17088969, 17088974, 17096208, 17096215, 17096201, 17096206, 17096432, 17096439, 17096425, 17096430, 17095984, 17095991, 17095977, 17095982, 17096144, 17096151, 17096137, 17096142, 17081872, 17081879, 17081865, 17081870, 17082096, 17082103, 17082089, 17082094, 17081648, 17081655, 17081641, 17081646, 17081808, 17081815, 17081801, 17081806, 17086992, 17086999, 17086985, 17086990, 17087216, 17087223, 17087209, 17087214, 17086768, 17086775, 17086761, 17086766, 17086928, 17086935, 17086921, 17086926, 17252880, 17252887, 17252873, 17252878, 17253104, 17253111, 17253097, 17253102, 17252656, 17252663, 17252649, 17252654, 17252816, 17252823, 17252809, 17252814, 17260048, 17260055, 17260041, 17260046, 17260272, 17260279, 17260265, 17260270, 17259824, 17259831, 17259817, 17259822, 17259984, 17259991, 17259977, 17259982, 17245712, 17245719, 17245705, 17245710, 17245936, 17245943, 17245929, 17245934, 17245488, 17245495, 17245481, 17245486, 17245648, 17245655, 17245641, 17245646, 17250832, 17250839, 17250825, 17250830, 17251056, 17251063, 17251049, 17251054, 17250608, 17250615, 17250601, 17250606, 17250768, 17250775, 17250761, 17250766, 24658448, 24658455, 24658441, 24658446, 24658672, 24658679, 24658665, 24658670, 24658224, 24658231, 24658217, 24658222, 24658384, 24658391, 24658377, 24658382, 24665616, 24665623, 24665609, 24665614, 24665840, 24665847, 24665833, 24665838, 24665392, 24665399, 24665385, 24665390, 24665552, 24665559, 24665545, 24665550, 24651280, 24651287, 24651273, 24651278, 24651504, 24651511, 24651497, 24651502, 24651056, 24651063, 24651049, 24651054, 24651216, 24651223, 24651209, 24651214, 24656400, 24656407, 24656393, 24656398, 24656624, 24656631, 24656617, 24656622, 24656176, 24656183, 24656169, 24656174, 24656336, 24656343, 24656329, 24656334, 24887824, 24887831, 24887817, 24887822, 24888048, 24888055, 24888041, 24888046, 24887600, 24887607, 24887593, 24887598, 24887760, 24887767, 24887753, 24887758, 24894992, 24894999, 24894985, 24894990, 24895216, 24895223, 24895209, 24895214, 24894768, 24894775, 24894761, 24894766, 24894928, 24894935, 24894921, 24894926, 24880656, 24880663, 24880649, 24880654, 24880880, 24880887, 24880873, 24880878, 24880432, 24880439, 24880425, 24880430, 24880592, 24880599, 24880585, 24880590, 24885776, 24885783, 24885769, 24885774, 24886e3, 24886007, 24885993, 24885998, 24885552, 24885559, 24885545, 24885550, 24885712, 24885719, 24885705, 24885710, 24429072, 24429079, 24429065, 24429070, 24429296, 24429303, 24429289, 24429294, 24428848, 24428855, 24428841, 24428846, 24429008, 24429015, 24429001, 24429006, 24436240, 24436247, 24436233, 24436238, 24436464, 24436471, 24436457, 24436462, 24436016, 24436023, 24436009, 24436014, 24436176, 24436183, 24436169, 24436174, 24421904, 24421911, 24421897, 24421902, 24422128, 24422135, 24422121, 24422126, 24421680, 24421687, 24421673, 24421678, 24421840, 24421847, 24421833, 24421838, 24427024, 24427031, 24427017, 24427022, 24427248, 24427255, 24427241, 24427246, 24426800, 24426807, 24426793, 24426798, 24426960, 24426967, 24426953, 24426958, 24592912, 24592919, 24592905, 24592910, 24593136, 24593143, 24593129, 24593134, 24592688, 24592695, 24592681, 24592686, 24592848, 24592855, 24592841, 24592846, 24600080, 24600087, 24600073, 24600078, 24600304, 24600311, 24600297, 24600302, 24599856, 24599863, 24599849, 24599854, 24600016, 24600023, 24600009, 24600014, 24585744, 24585751, 24585737, 24585742, 24585968, 24585975, 24585961, 24585966, 24585520, 24585527, 24585513, 24585518, 24585680, 24585687, 24585673, 24585678, 24590864, 24590871, 24590857, 24590862, 24591088, 24591095, 24591081, 24591086, 24590640, 24590647, 24590633, 24590638, 24590800, 24590807, 24590793, 24590798, 9978384, 9978391, 9978377, 9978382, 9978608, 9978615, 9978601, 9978606, 9978160, 9978167, 9978153, 9978158, 9978320, 9978327, 9978313, 9978318, 9985552, 9985559, 9985545, 9985550, 9985776, 9985783, 9985769, 9985774, 9985328, 9985335, 9985321, 9985326, 9985488, 9985495, 9985481, 9985486, 9971216, 9971223, 9971209, 9971214, 9971440, 9971447, 9971433, 9971438, 9970992, 9970999, 9970985, 9970990, 9971152, 9971159, 9971145, 9971150, 9976336, 9976343, 9976329, 9976334, 9976560, 9976567, 9976553, 9976558, 9976112, 9976119, 9976105, 9976110, 9976272, 9976279, 9976265, 9976270, 10207760, 10207767, 10207753, 10207758, 10207984, 10207991, 10207977, 10207982, 10207536, 10207543, 10207529, 10207534, 10207696, 10207703, 10207689, 10207694, 10214928, 10214935, 10214921, 10214926, 10215152, 10215159, 10215145, 10215150, 10214704, 10214711, 10214697, 10214702, 10214864, 10214871, 10214857, 10214862, 10200592, 10200599, 10200585, 10200590, 10200816, 10200823, 10200809, 10200814, 10200368, 10200375, 10200361, 10200366, 10200528, 10200535, 10200521, 10200526, 10205712, 10205719, 10205705, 10205710, 10205936, 10205943, 10205929, 10205934, 10205488, 10205495, 10205481, 10205486, 10205648, 10205655, 10205641, 10205646, 9749008, 9749015, 9749001, 9749006, 9749232, 9749239, 9749225, 9749230, 9748784, 9748791, 9748777, 9748782, 9748944, 9748951, 9748937, 9748942, 9756176, 9756183, 9756169, 9756174, 9756400, 9756407, 9756393, 9756398, 9755952, 9755959, 9755945, 9755950, 9756112, 9756119, 9756105, 9756110, 9741840, 9741847, 9741833, 9741838, 9742064, 9742071, 9742057, 9742062, 9741616, 9741623, 9741609, 9741614, 9741776, 9741783, 9741769, 9741774, 9746960, 9746967, 9746953, 9746958, 9747184, 9747191, 9747177, 9747182, 9746736, 9746743, 9746729, 9746734, 9746896, 9746903, 9746889, 9746894, 9912848, 9912855, 9912841, 9912846, 9913072, 9913079, 9913065, 9913070, 9912624, 9912631, 9912617, 9912622, 9912784, 9912791, 9912777, 9912782, 9920016, 9920023, 9920009, 9920014, 9920240, 9920247, 9920233, 9920238, 9919792, 9919799, 9919785, 9919790, 9919952, 9919959, 9919945, 9919950, 9905680, 9905687, 9905673, 9905678, 9905904, 9905911, 9905897, 9905902, 9905456, 9905463, 9905449, 9905454, 9905616, 9905623, 9905609, 9905614, 9910800, 9910807, 9910793, 9910798, 9911024, 9911031, 9911017, 9911022, 9910576, 9910583, 9910569, 9910574, 9910736, 9910743, 9910729, 9910734, 15221264, 15221271, 15221257, 15221262, 15221488, 15221495, 15221481, 15221486, 15221040, 15221047, 15221033, 15221038, 15221200, 15221207, 15221193, 15221198, 15228432, 15228439, 15228425, 15228430, 15228656, 15228663, 15228649, 15228654, 15228208, 15228215, 15228201, 15228206, 15228368, 15228375, 15228361, 15228366, 15214096, 15214103, 15214089, 15214094, 15214320, 15214327, 15214313, 15214318, 15213872, 15213879, 15213865, 15213870, 15214032, 15214039, 15214025, 15214030, 15219216, 15219223, 15219209, 15219214, 15219440, 15219447, 15219433, 15219438, 15218992, 15218999, 15218985, 15218990, 15219152, 15219159, 15219145, 15219150, 15450640, 15450647, 15450633, 15450638, 15450864, 15450871, 15450857, 15450862, 15450416, 15450423, 15450409, 15450414, 15450576, 15450583, 15450569, 15450574, 15457808, 15457815, 15457801, 15457806, 15458032, 15458039, 15458025, 15458030, 15457584, 15457591, 15457577, 15457582, 15457744, 15457751, 15457737, 15457742, 15443472, 15443479, 15443465, 15443470, 15443696, 15443703, 15443689, 15443694, 15443248, 15443255, 15443241, 15443246, 15443408, 15443415, 15443401, 15443406, 15448592, 15448599, 15448585, 15448590, 15448816, 15448823, 15448809, 15448814, 15448368, 15448375, 15448361, 15448366, 15448528, 15448535, 15448521, 15448526, 14991888, 14991895, 14991881, 14991886, 14992112, 14992119, 14992105, 14992110, 14991664, 14991671, 14991657, 14991662, 14991824, 14991831, 14991817, 14991822, 14999056, 14999063, 14999049, 14999054, 14999280, 14999287, 14999273, 14999278, 14998832, 14998839, 14998825, 14998830, 14998992, 14998999, 14998985, 14998990, 14984720, 14984727, 14984713, 14984718, 14984944, 14984951, 14984937, 14984942, 14984496, 14984503, 14984489, 14984494, 14984656, 14984663, 14984649, 14984654, 14989840, 14989847, 14989833, 14989838, 14990064, 14990071, 14990057, 14990062, 14989616, 14989623, 14989609, 14989614, 14989776, 14989783, 14989769, 14989774, 15155728, 15155735, 15155721, 15155726, 15155952, 15155959, 15155945, 15155950, 15155504, 15155511, 15155497, 15155502, 15155664, 15155671, 15155657, 15155662, 15162896, 15162903, 15162889, 15162894, 15163120, 15163127, 15163113, 15163118, 15162672, 15162679, 15162665, 15162670, 15162832, 15162839, 15162825, 15162830, 15148560, 15148567, 15148553, 15148558, 15148784, 15148791, 15148777, 15148782, 15148336, 15148343, 15148329, 15148334, 15148496, 15148503, 15148489, 15148494, 15153680, 15153687, 15153673, 15153678, 15153904, 15153911, 15153897, 15153902, 15153456, 15153463, 15153449, 15153454, 15153616, 15153623, 15153609]
        },
        ARUCO_MIP_36h12: {
          nBits: 36,
          tau: 12,
          codeList: [56562524317, 25770931429, 4839161458, 68596624564, 35931143241, 48420814492, 29449387539, 22088012831, 150160643, 38290206414, 63018100589, 7237360708, 48463388455, 12429895739, 32398847912, 10690557310, 36811505649, 20424594438, 51348452625, 59082132829, 4789649285, 6074601013, 60833300223, 17865158156, 38878348407, 9422290067, 52530265596, 1112263881, 11282798128, 31716556182, 55939809049, 65378188640, 53364103696, 16135388261, 10585857635, 18405277539, 58620300626, 16314326873, 45976886702, 36730781048, 49079839777, 48251450950, 9367376904, 46270871306, 45811842918, 20579384461, 24858916784, 45800689157, 1885099856, 46307169374, 30966095476, 37785816804, 61277293828, 48822885856, 10217422095, 64915480245, 43389267094, 6254111746, 8290563862, 37342276841, 28460125290, 3495333372, 6758227551, 7209929928, 55814160128, 56029470330, 36738889758, 18344320185, 58975059075, 44171881969, 49170624125, 3264591167, 65657841412, 41180650537, 42494701445, 36108643611, 34639993860, 28659990498, 26930865685, 15452591512, 7682723690, 52184653157, 35325736853, 15770954845, 14355922747, 3586151781, 12705066820, 36172812353, 26860166751, 55306861815, 4458230846, 52097670290, 14416739556, 18680720626, 63503185964, 21886004944, 12308700311, 12349350212, 17960603545, 41482020135, 38252944768, 36805791540, 10164380688, 9551813940, 38630526064, 39745661296, 34997908492, 4238126902, 28053085457, 30473796616, 4054545961, 43846990872, 20404992582, 8671648998, 46543146295, 35647704329, 17739867588, 36459700136, 32297088841, 21060713596, 51319791578, 58119572901, 9474224e3, 14900282644, 46136470867, 14594576121, 19808283810, 1010425331, 53297363037, 24692637543, 26359373345, 46113281484, 15179644549, 58533795373, 4434812905, 20743912811, 31920827745, 42332552509, 64106723953, 61987860015, 18286833283, 49956032501, 13203889835, 29235312165, 36521555341, 37903965709, 11787234849, 57448344684, 18958239524, 36489129683, 17809534842, 32896732754, 31847577168, 41236569844, 33564302914, 51585414251, 39285898823, 8882101696, 42729360772, 251636777, 33075363724, 27518016937, 55852068415, 7734342848, 40004287547, 66652317552, 15292841334, 14569959493, 55326630930, 32846929320, 5603651436, 25389875160, 48026662697, 918846935, 49642306667, 3924358743, 57089912602, 36525866802, 19258047537, 15798762340, 29623485812, 13931892113, 11469315373, 37306662699, 61910613086, 30606478781, 46814571538, 4917445926, 4439324737, 60918689504, 47457428851, 68021616262, 18332513560, 51148727658, 27928255740, 46173761192, 40760335900, 7855435272, 7001299726, 61833121153, 43896074151, 14605260403, 62541610373, 12393639381, 37350739731, 66194071346, 18666749070, 12382112924, 1680236413, 16493370640, 6059486961, 16751996745, 21543890275, 7001355285, 27046496066, 2804870197, 8337874016, 45455359079, 65272880397, 9060569084, 60159882672, 20975334688, 45716885065, 60604533827, 8739419880, 35574477989, 42573002072, 11905513436, 39802521107, 35050605614, 81139249, 55923865609, 42972972333, 38492698169, 54935698999, 54512761978, 67740646995, 41511353392, 50981879100, 60163858300, 20282826672, 49415583287, 13921455465, 4465851981, 53900345171, 59632123755, 19009048020, 13643781953, 30188444676, 20762705568]
        }
      };
      AR.Dictionary = function(dicName) {
        this.codes = {};
        this.codeList = [];
        this.tau = 0;
        this._initialize(dicName);
      };
      AR.Dictionary.prototype._initialize = function(dicName) {
        this.codes = {};
        this.codeList = [];
        this.tau = 0;
        this.nBits = 0;
        this.markSize = 0;
        this.dicName = dicName;
        var dictionary = AR.DICTIONARIES[dicName];
        if (!dictionary)
          throw 'The dictionary "' + dicName + '" is not recognized.';
        this.nBits = dictionary.nBits;
        this.markSize = Math.sqrt(dictionary.nBits) + 2;
        for (var i = 0; i < dictionary.codeList.length; i++) {
          var code = null;
          if (typeof dictionary.codeList[i] === "number")
            code = this._hex2bin(dictionary.codeList[i], dictionary.nBits);
          if (typeof dictionary.codeList[i] === "string")
            code = this._hex2bin(parseInt(dictionary.codeList[i], 16), dictionary.nBits);
          if (Array.isArray(dictionary.codeList[i]))
            code = this._bytes2bin(dictionary.codeList[i], dictionary.nBits);
          if (code === null)
            throw "Invalid code " + i + " in dictionary " + dicName + ": " + JSON.stringify(dictionary.codeList[i]);
          if (code.length != dictionary.nBits)
            throw "The code " + i + " in dictionary " + dicName + " is not " + dictionary.nBits + " bits long but " + code.length + ": " + code;
          this.codeList.push(code);
          this.codes[code] = {
            id: i
          };
        }
        this.tau = dictionary.tau || this._calculateTau();
      };
      AR.Dictionary.prototype.find = function(bits) {
        var val = "", i, j;
        for (i = 0; i < bits.length; i++) {
          var bitRow = bits[i];
          for (j = 0; j < bitRow.length; j++) {
            val += bitRow[j];
          }
        }
        var minFound = this.codes[val];
        if (minFound)
          return {
            id: minFound.id,
            distance: 0
          };
        for (i = 0; i < this.codeList.length; i++) {
          var code = this.codeList[i];
          var distance = this._hammingDistance(val, code);
          if (this._hammingDistance(val, code) < this.tau) {
            if (!minFound || minFound.distance > distance) {
              minFound = {
                id: this.codes[code].id,
                distance
              };
            }
          }
        }
        return minFound;
      };
      AR.Dictionary.prototype._hex2bin = function(hex, nBits) {
        return hex.toString(2).padStart(nBits, "0");
      };
      AR.Dictionary.prototype._bytes2bin = function(byteList, nBits) {
        var bits = "", byte;
        for (byte of byteList) {
          bits += byte.toString(2).padStart(bits.length + 8 > nBits ? nBits - bits.length : 8, "0");
        }
        return bits;
      };
      AR.Dictionary.prototype._hammingDistance = function(str1, str2) {
        if (str1.length != str2.length)
          throw "Hamming distance calculation require inputs of the same length";
        var distance = 0, i;
        for (i = 0; i < str1.length; i++)
          if (str1[i] !== str2[i])
            distance += 1;
        return distance;
      };
      AR.Dictionary.prototype._calculateTau = function() {
        var tau = Number.MAX_VALUE;
        for (var i = 0; i < this.codeList.length; i++)
          for (var j = i + 1; j < this.codeList.length; j++) {
            var distance = this._hammingDistance(this.codeList[i], this.codeList[j]);
            tau = distance < tau ? distance : tau;
          }
        return tau;
      };
      AR.Dictionary.prototype.generateSVG = function(id) {
        var code = this.codeList[id];
        if (code == null)
          throw 'The id "' + id + '" is not valid for the dictionary "' + this.dicName + '". ID must be between 0 and ' + (this.codeList.length - 1) + " included.";
        var size = this.markSize - 2;
        var svg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ' + (size + 4) + " " + (size + 4) + '">';
        svg += '<rect x="0" y="0" width="' + (size + 4) + '" height="' + (size + 4) + '" fill="white"/>';
        svg += '<rect x="1" y="1" width="' + (size + 2) + '" height="' + (size + 2) + '" fill="black"/>';
        for (var y = 0; y < size; y++) {
          for (var x = 0; x < size; x++) {
            if (code[y * size + x] == "1")
              svg += '<rect x="' + (x + 2) + '" y="' + (y + 2) + '" width="1" height="1" fill="white"/>';
          }
        }
        svg += "</svg>";
        return svg;
      };
      AR.Marker = function(id, corners, hammingDistance) {
        this.id = id;
        this.corners = corners;
        this.hammingDistance = hammingDistance;
      };
      AR.Detector = function(config) {
        config = config || {};
        this.grey = new CV.Image();
        this.thres = new CV.Image();
        this.homography = new CV.Image();
        this.binary = [];
        this.contours = [];
        this.polys = [];
        this.candidates = [];
        config.dictionaryName = config.dictionaryName || "ARUCO_MIP_36h12";
        this.dictionary = new AR.Dictionary(config.dictionaryName);
        this.dictionary.tau = config.maxHammingDistance != null ? config.maxHammingDistance : this.dictionary.tau;
      };
      AR.Detector.prototype.detectImage = function(width, height, data) {
        return this.detect({
          width,
          height,
          data
        });
      };
      AR.Detector.prototype.detectStreamInit = function(width, height, callback) {
        this.streamConfig = {};
        this.streamConfig.width = width;
        this.streamConfig.height = height;
        this.streamConfig.imageSize = width * height * 4;
        this.streamConfig.index = 0;
        this.streamConfig.imageData = new Uint8ClampedArray(this.streamConfig.imageSize);
        this.streamConfig.callback = callback || function(image, markerList) {
        };
      };
      AR.Detector.prototype.detectStream = function(data) {
        for (var i = 0; i < data.length; i++) {
          this.streamConfig.imageData[this.streamConfig.index] = data[i];
          this.streamConfig.index = (this.streamConfig.index + 1) % this.streamConfig.imageSize;
          if (this.streamConfig.index == 0) {
            var image = {
              width: this.streamConfig.width,
              height: this.streamConfig.height,
              data: this.streamConfig.imageData
            };
            var markerList = this.detect(image);
            this.streamConfig.callback(image, markerList);
          }
        }
      };
      AR.Detector.prototype.detectMJPEGStreamInit = function(width, height, callback, decoderFn) {
        this.mjpeg = {
          decoderFn,
          chunks: [],
          SOI: [255, 216],
          EOI: [255, 217]
        };
        this.detectStreamInit(width, height, callback);
      };
      AR.Detector.prototype.detectMJPEGStream = function(chunk) {
        var eoiPos = chunk.findIndex(function(element, index, array) {
          return this.mjpeg.EOI[0] == element && array.length > index + 1 && this.mjpeg.EOI[1] == array[index + 1];
        });
        var soiPos = chunk.findIndex(function(element, index, array) {
          return this.mjpeg.SOI[0] == element && array.length > index + 1 && this.mjpeg.SOI[1] == array[index + 1];
        });
        if (eoiPos === -1) {
          this.mjpeg.chunks.push(chunk);
        } else {
          var part1 = chunk.slice(0, eoiPos + 2);
          if (part1.length) {
            this.mjpeg.chunks.push(part1);
          }
          if (this.mjpeg.chunks.length) {
            var jpegImage = this.mjpeg.chunks.flat();
            var rgba = this.mjpeg.decoderFn(jpegImage);
            this.detectStream(rgba);
          }
          this.mjpeg.chunks = [];
        }
        if (soiPos > -1) {
          this.mjpeg.chunks = [];
          this.mjpeg.chunks.push(chunk.slice(soiPos));
        }
      };
      AR.Detector.prototype.detect = function(image) {
        CV.grayscale(image, this.grey);
        CV.adaptiveThreshold(this.grey, this.thres, 2, 7);
        this.contours = CV.findContours(this.thres, this.binary);
        this.candidates = this.findCandidates(this.contours, image.width * 0.01, 0.05, 10);
        this.candidates = this.clockwiseCorners(this.candidates);
        this.candidates = this.notTooNear(this.candidates, 10);
        return this.findMarkers(this.grey, this.candidates, 49);
      };
      AR.Detector.prototype.findCandidates = function(contours, minSize, epsilon, minLength) {
        var candidates = [], len = contours.length, contour, poly, i;
        this.polys = [];
        for (i = 0; i < len; ++i) {
          contour = contours[i];
          if (contour.length >= minSize) {
            poly = CV.approxPolyDP(contour, contour.length * epsilon);
            this.polys.push(poly);
            if (4 === poly.length && CV.isContourConvex(poly)) {
              if (CV.minEdgeLength(poly) >= minLength) {
                candidates.push(poly);
              }
            }
          }
        }
        return candidates;
      };
      AR.Detector.prototype.clockwiseCorners = function(candidates) {
        var len = candidates.length, dx1, dx2, dy1, dy2, swap, i;
        for (i = 0; i < len; ++i) {
          dx1 = candidates[i][1].x - candidates[i][0].x;
          dy1 = candidates[i][1].y - candidates[i][0].y;
          dx2 = candidates[i][2].x - candidates[i][0].x;
          dy2 = candidates[i][2].y - candidates[i][0].y;
          if (dx1 * dy2 - dy1 * dx2 < 0) {
            swap = candidates[i][1];
            candidates[i][1] = candidates[i][3];
            candidates[i][3] = swap;
          }
        }
        return candidates;
      };
      AR.Detector.prototype.notTooNear = function(candidates, minDist) {
        var notTooNear = [], len = candidates.length, dist, dx, dy, i, j, k;
        for (i = 0; i < len; ++i) {
          for (j = i + 1; j < len; ++j) {
            dist = 0;
            for (k = 0; k < 4; ++k) {
              dx = candidates[i][k].x - candidates[j][k].x;
              dy = candidates[i][k].y - candidates[j][k].y;
              dist += dx * dx + dy * dy;
            }
            if (dist / 4 < minDist * minDist) {
              if (CV.perimeter(candidates[i]) < CV.perimeter(candidates[j])) {
                candidates[i].tooNear = true;
              } else {
                candidates[j].tooNear = true;
              }
            }
          }
        }
        for (i = 0; i < len; ++i) {
          if (!candidates[i].tooNear) {
            notTooNear.push(candidates[i]);
          }
        }
        return notTooNear;
      };
      AR.Detector.prototype.findMarkers = function(imageSrc, candidates, warpSize) {
        var markers = [], len = candidates.length, candidate, marker, i;
        for (i = 0; i < len; ++i) {
          candidate = candidates[i];
          CV.warp(imageSrc, this.homography, candidate, warpSize);
          CV.threshold(this.homography, this.homography, CV.otsu(this.homography));
          marker = this.getMarker(this.homography, candidate);
          if (marker) {
            markers.push(marker);
          }
        }
        return markers;
      };
      AR.Detector.prototype.getMarker = function(imageSrc, candidate) {
        var markSize = this.dictionary.markSize;
        var width = imageSrc.width / markSize >>> 0, minZero = width * width >> 1, bits = [], rotations = [], square, inc, i, j;
        for (i = 0; i < markSize; ++i) {
          inc = 0 === i || markSize - 1 === i ? 1 : markSize - 1;
          for (j = 0; j < markSize; j += inc) {
            square = {
              x: j * width,
              y: i * width,
              width,
              height: width
            };
            if (CV.countNonZero(imageSrc, square) > minZero) {
              return null;
            }
          }
        }
        for (i = 0; i < markSize - 2; ++i) {
          bits[i] = [];
          for (j = 0; j < markSize - 2; ++j) {
            square = {
              x: (j + 1) * width,
              y: (i + 1) * width,
              width,
              height: width
            };
            bits[i][j] = CV.countNonZero(imageSrc, square) > minZero ? 1 : 0;
          }
        }
        rotations[0] = bits;
        var foundMin = null;
        var rot = 0;
        for (i = 0; i < 4; i++) {
          var found = this.dictionary.find(rotations[i]);
          if (found && (foundMin === null || found.distance < foundMin.distance)) {
            foundMin = found;
            rot = i;
            if (foundMin.distance === 0)
              break;
          }
          rotations[i + 1] = this.rotate(rotations[i]);
        }
        if (foundMin)
          return new AR.Marker(foundMin.id, this.rotate2(candidate, 4 - rot), foundMin.distance);
        return null;
      };
      AR.Detector.prototype.rotate = function(src) {
        var dst = [], len = src.length, i, j;
        for (i = 0; i < len; ++i) {
          dst[i] = [];
          for (j = 0; j < src[i].length; ++j) {
            dst[i][j] = src[src[i].length - j - 1][i];
          }
        }
        return dst;
      };
      AR.Detector.prototype.rotate2 = function(src, rotation) {
        var dst = [], len = src.length, i;
        for (i = 0; i < len; ++i) {
          dst[i] = src[(rotation + i) % len];
        }
        return dst;
      };
    }
  });

  // scripts/sti-card-detector.js
  var require_sti_card_detector = __commonJS({
    "scripts/sti-card-detector.js"(exports, module) {
      /*!
       * js-aruco2
       * Copyright (c) 2020 Damiano Falcioni
       * Copyright (c) 2011 Juan Mellado
       *
       * Permission is hereby granted, free of charge, to any person obtaining a copy
       * of this software and associated documentation files (the "Software"), to deal
       * in the Software without restriction, including without limitation the rights
       * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
       * copies of the Software, and to permit persons to whom the Software is
       * furnished to do so, subject to the following conditions:
       *
       * The above copyright notice and this permission notice shall be included in
       * all copies or substantial portions of the Software.
       *
       * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
       * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
       * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
       * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
       * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
       * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
       * THE SOFTWARE.
       */
      var { AR } = require_aruco();
      AR.DICTIONARIES.STI_CC24 = {
        nBits: 16,
        tau: 1,
        codeList: [46386, 3994, 13101, 39238]
      };
      function validateMarkers(markers) {
        const expected = [0, 1, 2, 3];
        const relevant = markers.filter((marker) => expected.includes(marker.id));
        if (relevant.length !== new Set(relevant.map((marker) => marker.id)).size) {
          throw new Error("More than one card or duplicate markers were found. Photograph one card only.");
        }
        if (relevant.length !== 4) {
          throw new Error(`All four card markers were not found (${relevant.length}/4). Retake the photo with the full card larger, flat and in focus.`);
        }
        return relevant.sort((a, b) => a.id - b.id);
      }
      function detectCard(imageData) {
        if (!imageData || !imageData.data || !imageData.width || !imageData.height) {
          throw new Error("The photo is not ready. Upload it again.");
        }
        const detector = new AR.Detector({ dictionaryName: "STI_CC24", maxHammingDistance: 1 });
        const markers = detector.detect(imageData).map((marker) => ({
          id: marker.id,
          corners: marker.corners.map((point) => ({ x: point.x, y: point.y })),
          center: {
            x: marker.corners.reduce((sum, point) => sum + point.x, 0) / 4,
            y: marker.corners.reduce((sum, point) => sum + point.y, 0) / 4
          }
        }));
        return { markers: validateMarkers(markers) };
      }
      var api = { detectCard, validateMarkers };
      if (typeof window !== "undefined") window.STICardDetector = api;
      module.exports = api;
    }
  });
  require_sti_card_detector();
})();
